import React from 'react';

import { Arrow, Content, Dot, Icon, IconChevron, IconInfo, Item, Label, Note } from './styles';

type Props = {
  label: string;
  isActive?: boolean;
  menuIcon: JSX.Element;
  hasNote?: boolean;
  note?: string;
  onClick: () => void;
};

const MenuItem = ({ label, isActive = false, menuIcon, hasNote = false, note, onClick }: Props) => (
  <Item onClick={onClick}>
    <Content>
      <Label>
        <Icon>{menuIcon}</Icon>
        {label} {isActive && <Dot />}
      </Label>
      <Arrow>
        <IconChevron />
      </Arrow>
    </Content>
    {hasNote && (
      <Note>
        <IconInfo />
        {note}
      </Note>
    )}
  </Item>
);
export default MenuItem;
